import { KEYCODES, CLASSES } from "@/scripts/helpers/constants";
import UslfSearch from "@/modules/components/uslf-search";

import { trackResponse } from "@/scripts/helpers/tracking";

export const usliSearchHeader = new UslfSearch("#searchForm");

const selectMask = $(".js-search-select-mask");
const userInfoAction = $(".js-user-info-combobox");
const mobileSearchAction = $(
  ".header-navbar__item--search .header-navbar__item-action"
);
const tabletSearchAction = $(".js-search-tablet-action");

const buttonSelectStateChangeSelector = $(".js-select-state-change");
const buttonSelectStateApplySelector = $(".js-select-state-apply");

export const handleTrackMyAccount = () => {
  $(".user-info__options-list-link").on("click", function() {
    trackResponse({
      name: $(this).attr("data-name")
    });
  });
};

export const handleUserInfoAction = () => {
  userInfoAction.on("click", function() {
    mobileSearchAction.removeClass("is-active");
    $(this).toggleClass("is-open");
  });

  userInfoAction.on("keypress", function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.keyCode === KEYCODES.SPACE || e.keyCode === KEYCODES.ENTER) {
      mobileSearchAction.removeClass("is-active");
      $(this).toggleClass("is-open");
    }
  });
};

export const handleTabletSearch = () => {
  tabletSearchAction.on("click", function() {
    $(".header__nav").toggle();
    $(this).toggleClass(CLASSES.ACTIVE);
  });
};

export const handleComboboxClose = () => {
  $(document).on("click", function(event) {
    if (!$(event.target).closest(userInfoAction).length) {
      userInfoAction.removeClass("is-open");
    }

    if (!$(event.target).closest(selectMask).length) {
      selectMask.removeClass(CLASSES.ACTIVE);
    }
  });
};

export const headerHoverHandler = () => {
  const headerNavItemsSelector = $(".header__nav-item");

  if (headerNavItemsSelector) {
    headerNavItemsSelector.hover(
      function() {
        $(this).addClass(CLASSES.OPEN);
      },
      function() {
        $(this).removeClass(CLASSES.OPEN);
      }
    );
  }
};

const lastElementBlurHandler = (parentElement, lastElement) => {
  let categoriesLink = parentElement.find(lastElement);
  const lasCategoriesLinkIndex = categoriesLink.length - 1;
  const lastCategoriesLink = categoriesLink[lasCategoriesLinkIndex];

  $(lastCategoriesLink).blur(function() {
    parentElement.removeClass(CLASSES.OPEN);
  });
};

export const headerTabulationHandler = () => {
  const headerNavItemsSelector = $(".header__nav-item");

  if (headerNavItemsSelector) {
    headerNavItemsSelector.each(function() {
      const parentElement = $(this);

      parentElement.focus(function() {
        parentElement.addClass(CLASSES.OPEN);

        // handler for shift + tab press
        parentElement.keydown(function(event) {
          if (
            $(event.target).hasClass("header__nav-item") &&
            event.shiftKey &&
            event.key === "Tab"
          ) {
            parentElement.removeClass(CLASSES.OPEN);
          }
        });
      });

      // links without submenu
      parentElement.find(".header__nav-link").focus(function() {
        $(this)
          .parent()
          .addClass(CLASSES.OPEN);
      });

      parentElement.find(".header__nav-link").blur(function() {
        $(this)
          .parent()
          .removeClass(CLASSES.OPEN);
      });

      // if dropdown has 'tags' - remove is-open class after last tag lost focus
      if (parentElement.find(".tags").length) {
        let submenuTagsLink = parentElement.find(".tags .tags-list__link");
        lastElementBlurHandler(parentElement, submenuTagsLink);
      } else if (parentElement.find(".categories-list a").length) {
        // else - dropdown without tags - remove is-open class after last submenu lost focus
        let categoriesLink = parentElement.find(".categories-list a");
        lastElementBlurHandler(parentElement, categoriesLink);
      } else {
        let myAccountLinks = parentElement.find(
          ".user-info__options-list-link"
        );
        lastElementBlurHandler(parentElement, myAccountLinks);
      }
    });
  }
};
